import {
  BOGGLE_GOLD_SCORE_BONUS,
  BOGGLE_GOLD_TILE_KIND,
} from '../kinds'
import type { BoggleSpecialTileDefinition } from '../tileTypes'

export const goldTileDefinition: BoggleSpecialTileDefinition = {
  description: 'Scores +1 point when played',
  kind: BOGGLE_GOLD_TILE_KIND,
  label: 'Gold',
  previewFill: '#5e4307',
  previewTextColor: '#ffefc0',
  scoreBonusPerPathPosition: BOGGLE_GOLD_SCORE_BONUS,
  timeBonusPerWordMs: 0,
  tileShape: 'hexagon',
}
